import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import TransferPending from './pending/transfer_pending';
import PageHeaderComponent from '../../helpers/components/page_header.component';

const StockRequest = () => {
    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <PageHeaderComponent />
                <TransferPending />
            </ContainerComponent>
        </>
    );
}

export default StockRequest;